<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>流向</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.source_account_code">
                <el-input
                    v-model="queryParams.source_account_code"
                    placeholder="请输入源账户代码"
                    clearable
                    @keyup.enter.native="getList(0, 1)"
                ></el-input>
            </div>
            <div class="main_header_item" v-if="postList.commodity_flow_source_rid">
                <el-input
                    v-model="queryParams.commodity_flow_source_rid"
                    placeholder="请输入流向源RID"
                    clearable
                    @keyup.enter.native="getList(0, 1)"
                ></el-input>
            </div>
            <div class="main_header_item" v-if="postList.rid">
                <el-input v-model="queryParams.rid" placeholder="请输入流向RID" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>

            <div class="main_header_item" v-if="postList.source_account_rid">
                <vSearchSelect
                    model_key="source_account_rid"
                    model_name="请输入源账户搜索"
                    request_uri="searchAccounts"
                    default_option_key="source_account_option"
                    :default_option="queryParams['source_account_option']"
                    @onDropChange="onDropChange"
                    ref="source_account_rid_ref"
                ></vSearchSelect>
            </div>
            <div class="main_header_item" v-if="postList.tag">
                <vDropdown
                    model_key="tag"
                    model_name="请选择标签"
                    select_value="value"
                    request_uri="commodityFlowSourceTag"
                    :model_value_default="queryParams['tag']"
                    @onDropChange="onDropChange"
                    ref="tag_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-if="postList.source_demander">
                <el-input
                    v-model="queryParams.source_demander_name"
                    placeholder="请输入源需方"
                    clearable
                    @keyup.enter.native="getList(0, 1)"
                ></el-input>
            </div>
            <div class="main_header_item" v-if="postList.source_file">
                <el-input
                    v-model="queryParams.source_file"
                    placeholder="请输入源文件"
                    clearable
                    @keyup.enter.native="getList(0, 1)"
                ></el-input>
            </div>
            <div class="main_header_item" v-if="postList.product_rid">
                <vDropdown
                    model_key="product_rid"
                    model_name="请选择产品"
                    :model_value_default="queryParams['product_rid']"
                    request_uri="dropdownProducts"
                    :request_params="{ is_all: true, type_code: [11, 91] }"
                    @onDropChange="onDropChange"
                    ref="product_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-if="postList.partner_rid">
                <vDropdown
                    model_key="partner_rid"
                    model_name="请选择合作方"
                    :model_value_default="queryParams['partner_rid']"
                    request_uri="dropdownPartners"
                    @onDropChange="onDropChange"
                    ref="partner_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-if="postList.demander_rid">
                <vSearchSelect
                    model_key="demander_rid"
                    model_name="请输入需方搜索"
                    request_uri="searchAccounts"
                    default_option_key="demander_option"
                    :default_option="queryParams['demander_option']"
                    @onDropChange="onDropChange"
                    ref="demander_rid_ref"
                ></vSearchSelect>
            </div>

            <div class="main_header_item" v-if="postList.supplier_rid">
                <vSearchSelect
                    model_key="supplier_rid"
                    model_name="请输入供方搜索"
                    request_uri="searchAccounts"
                    default_option_key="supplier_option"
                    :default_option="queryParams['supplier_option']"
                    @onDropChange="onDropChange"
                    ref="supplier_rid_ref"
                ></vSearchSelect>
            </div>

            <div class="main_header_item" v-if="postList.sup_supplier_rid">
                <vSearchSelect
                    model_key="sup_supplier_rid"
                    model_name="请输入上级供方搜索"
                    request_uri="searchAccounts"
                    default_option_key="sup_supplier_option"
                    :default_option="queryParams['sup_supplier_option']"
                    @onDropChange="onDropChange"
                    ref="sup_supplier_rid_ref"
                ></vSearchSelect>
            </div>

            <div class="main_header_item" v-if="postList.business_rid">
                <vSearchSelect
                    model_key="business_rid"
                    model_name="请输入一级商业搜索"
                    request_uri="searchAccounts"
                    default_option_key="business_option"
                    :default_option="queryParams['business_option']"
                    @onDropChange="onDropChange"
                    ref="business_rid_ref"
                ></vSearchSelect>
            </div>

            <div class="main_header_item" v-if="postList.ta_rid">
                <vSearchSelect
                    model_key="ta_rid"
                    model_name="请输入终端授权搜索"
                    search_key="code"
                    request_uri="searchTerminalAuthorizations"
                    default_option_key="ta_option"
                    :default_option="queryParams['ta_option']"
                    @onDropChange="onDropChange"
                    ref="ta_rid_ref"
                ></vSearchSelect>
            </div>

            <div class="main_header_item" v-if="postList.no_demander">
                <vDropdown
                    model_key="no_demander"
                    model_name="请选择需方是否为空"
                    select_value="value"
                    request_uri="yesOrNo"
                    :model_value_default="queryParams['no_demander']"
                    @onDropChange="onDropChange"
                    ref="no_demander_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item" v-if="postList.no_supplier">
                <vDropdown
                    model_key="no_supplier"
                    model_name="请选择供方是否为空"
                    select_value="value"
                    request_uri="yesOrNo"
                    :model_value_default="queryParams['no_supplier']"
                    @onDropChange="onDropChange"
                    ref="no_supplier_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item" v-if="postList.no_product">
                <vDropdown
                    model_key="no_product"
                    model_name="请选择产品是否为空"
                    select_value="value"
                    request_uri="yesOrNo"
                    :model_value_default="queryParams['no_product']"
                    @onDropChange="onDropChange"
                    ref="no_product_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item" v-if="postList.no_partner">
                <vDropdown
                    model_key="no_partner"
                    model_name="请选择合作方是否为空"
                    select_value="value"
                    request_uri="yesOrNo"
                    :model_value_default="queryParams['no_partner']"
                    @onDropChange="onDropChange"
                    ref="no_partner_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item" v-if="postList.no_business">
                <vDropdown
                    model_key="no_business"
                    model_name="请选择一级商业是否为空"
                    select_value="value"
                    request_uri="yesOrNo"
                    :model_value_default="queryParams['no_business']"
                    @onDropChange="onDropChange"
                    ref="no_business_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item" v-if="postList.date_range">
                <el-date-picker
                    v-model="queryParams['date_range']"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    size="small"
                    style="width: 300px"
                >
                </el-date-picker>
            </div>

            <div class="main_header_item" v-show="postList.month">
                <el-input v-model="queryParams.month" placeholder="请输入月份" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>

            <div class="main_header_item" v-show="postList.ppa_code">
                <el-input v-model="queryParams.ppa_code" placeholder="请输入PPA编码" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>

            <div class="main_header_item">
                <vDropdown
                    model_key="is_ppa"
                    model_name="请选择是否PPA流向"
                    select_value="value"
                    request_uri="yesOrNo"
                    :model_value_default="queryParams['is_ppa']"
                    @onDropChange="onDropChange"
                    ref="is_ppa_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item">
                <vDropdown
                    model_key="performance_unit_code"
                    model_name="请选择绩效单元"
                    :model_value_default="queryParams['performance_unit_code']"
                    request_uri="dropdownPerformanceUnit"
                    select_value="code"
                    @onDropChange="onDropChange"
                    ref="performance_unit_code_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item">
                <vDropdown
                    model_key="business_unit_code"
                    model_name="请选择业务单元"
                    :model_value_default="queryParams['business_unit_code']"
                    request_uri="dropdownBusinessUnits"
                    select_value="code"
                    @onDropChange="onDropChange"
                    ref="business_unit_code_ref"
                ></vDropdown>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="insert" v-if="postList.insertBtn" :loading="btnLoading" icon="el-icon-plus">新增</el-button>
                <el-button size="small" plain @click="flushAcount" v-if="postList.updateBtn" :loading="btnLoading">刷新流向</el-button>
                <el-button size="small" plain @click="relationProduct" v-if="postList.productBtn" :loading="btnLoading">关联产品</el-button>
                <el-button size="small" plain @click="relationSupplier" v-if="postList.supplierBtn" :loading="btnLoading"
                    >关联供方</el-button
                >
                <el-button size="small" plain @click="relationDemander" v-if="postList.demanderBtn" :loading="btnLoading"
                    >关联需方</el-button
                >
                <el-button size="small" plain @click="flushIsPpa" :loading="btnLoading">刷新PPA标记</el-button>

                <el-button size="small" plain @click="flushPerformanceUnitCode()" :loading="btnLoading">刷新绩效单元</el-button>

                <el-button size="small" plain @click="flushBusinessUnitCode()" :loading="btnLoading">刷新业务单元</el-button>

                <el-button size="small" plain @click="show_help()" icon="el-icon-question">帮助信息</el-button>

                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(2)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <crm-upload obj="commodity_flow" :queryParams="queryParams" v-if="postList.uploadBtn"></crm-upload>
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone" v-if="postList.setBtn"></draggableList>
                </div>
            </div>

            <div v-show="is_show_help">
                <div class="flex">
                    <span style="color: red; font-size: 13px"
                        >请选择是否PPA流向(基于PPA标记)存在一定时间差，每天凌晨会自动刷新。可点击"刷新PPA标记"进行刷新，耗时较久，请勿频繁点击。刷新期间不要操作流向、PPA、PPAP等</span
                    >
                </div>
                <div class="flex">
                    <span style="color: red; font-size: 13px"
                        >刷新绩效单元、刷新业务单元耗时较久（每天凌晨会自动刷新一次），请按需点击，请勿频繁点击。刷新期间不要操作流向、PPA、PPAP、绩效归属等</span
                    >
                </div>
            </div>

            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="commodity_flow"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div
                                v-if="
                                    item.prop == 'product' ||
                                    item.prop == 'demander' ||
                                    item.prop == 'supplier' ||
                                    item.prop == 'sup_supplier' ||
                                    item.prop == 'business' ||
                                    item.prop == 'partner' ||
                                    item.prop == 'representative'
                                "
                            >
                                <span v-if="scope.row[item.prop]"> {{ scope.row[item.prop].name }} </span>
                            </div>
                            <div v-else-if="item.prop == 'performance_unit_name'">
                                <span v-if="scope.row['performance_unit']"> {{ scope.row['performance_unit'].name }} </span>
                            </div>
                            <div v-else-if="item.prop == 'performance_unit_id'">
                                <span v-if="scope.row['performance_unit']"> {{ scope.row['performance_unit'].id }} </span>
                            </div>
                            <div v-else-if="item.prop == 'business_unit_name'">
                                <span v-if="scope.row['business_unit']"> {{ scope.row['business_unit'].name }} </span>
                            </div>
                            <div v-else-if="item.prop == 'ta'">
                                <span v-if="scope.row[item.prop]"> {{ scope.row[item.prop].code }} </span>
                            </div>
                            <div v-else-if="item.prop == 'source_account_rid'">
                                <span v-if="scope.row.source.account"> {{ scope.row.source.account.rid }} </span>
                            </div>
                            <div v-else-if="item.prop == 'source_account_name'">
                                <span v-if="scope.row.source.account"> {{ scope.row.source.account.name }} </span>
                            </div>
                            <div v-else-if="item.prop == 'source_account_code'">
                                <span v-if="scope.row.source.account"> {{ scope.row.source.account.code }} </span>
                            </div>
                            <!-- extension -->
                            <div v-else-if="item.prop == 'PT'">
                                <span v-if="scope.row.extension.price_taxincluded"> {{ scope.row.extension.price_taxincluded }} </span>
                            </div>
                            <div v-else-if="item.prop == 'EQF'">
                                <span v-if="scope.row.extension.expense_quota_flow"> {{ scope.row.extension.expense_quota_flow }} </span>
                            </div>
                            <div v-else-if="item.prop == 'EQA'">
                                <span v-if="scope.row.extension.expense_quota_adjusted">
                                    {{ scope.row.extension.expense_quota_adjusted }}
                                </span>
                            </div>
                            <div v-else-if="item.prop == 'SSR'">
                                <span v-if="scope.row.extension.sales_standard_revenue">
                                    {{ scope.row.extension.sales_standard_revenue }}
                                </span>
                            </div>
                            <div v-else-if="item.prop == 'SSM'">
                                <span v-if="scope.row.extension.sales_standard_margin">
                                    {{ scope.row.extension.sales_standard_margin }}
                                </span>
                            </div>
                            <div v-else-if="item.prop == 'EQF_STATUS'">
                                <span v-if="scope.row.extension.expense_quota_flow_status_label">
                                    {{ scope.row.extension.expense_quota_flow_status_label }}
                                </span>
                            </div>
                            <div v-else-if="item.prop == 'EQFM'">
                                <span v-if="scope.row.extension.expense_quota_flow_adjustment">
                                    {{ scope.row.extension.expense_quota_flow_adjustment }}
                                </span>
                            </div>
                            <div v-else-if="item.prop == 'EQFCA'">
                                <span v-if="scope.row.extension.expense_quota_flow_confirmed_adjusted">
                                    {{ scope.row.extension.expense_quota_flow_confirmed_adjusted }}
                                </span>
                            </div>
                            <!-- source -->
                            <div
                                v-else-if="
                                    item.prop == 'source_product_unit' ||
                                    item.prop == 'source_credential_rid' ||
                                    item.prop == 'source_credential_code' ||
                                    item.prop == 'tag_label' ||
                                    item.prop == 'source_date_delivery' ||
                                    item.prop == 'source_date' ||
                                    item.prop == 'source_voucher_type' ||
                                    item.prop == 'source_total_price_tax_included' ||
                                    item.prop == 'source_unit_price_tax_included' ||
                                    item.prop == 'source_total_price_tax_excluded' ||
                                    item.prop == 'source_unit_price_tax_excluded' ||
                                    item.prop == 'source_quantity' ||
                                    item.prop == 'source_product_batch_number' ||
                                    item.prop == 'source_product_specification' ||
                                    item.prop == 'source_product_name' ||
                                    item.prop == 'source_product_code' ||
                                    item.prop == 'source_demander_name' ||
                                    item.prop == 'source_demander_code' ||
                                    item.prop == 'source_file' ||
                                    item.prop == 'source_supplier_code' ||
                                    item.prop == 'source_supplier_name' ||
                                    item.prop == 'source_sup_supplier_name' ||
                                    item.prop == 'source_business_code' ||
                                    item.prop == 'source_partner_code' ||
                                    item.prop == 'source_promotion_type' ||
                                    item.prop == 'source_performance' ||
                                    item.prop == 'comment'
                                "
                            >
                                <span> {{ scope.row.source[item.prop] }} </span>
                            </div>
                            <div v-else-if="in_array(item.prop, ['rid', 'ppa_code'])">
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="update(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="del(scope.row)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array, onDelete } from '../../../../../js/common.js';
import draggableList from '../../../../common/Drawer.vue';
import vSearchSelect from '@/components/common/dropdown/search.vue';
import crmUpload from '../../../../common/Upload.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        vSearchSelect,
        crmUpload
    },
    name: 'commodityFlowComponent',
    data() {
        return {
            draggable: {
                data_name: 'commodity_flow'
            },
            is_show_help: false,
            btnLoading: false,
            down_loading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();

            if (this.postList.params) {
                this.queryParams.row = 25;

                if (this.postList.params.config01_rid) {
                    this.queryParams.config01_rid = this.postList.params.config01_rid;
                }

                if (this.postList.params.ppa_code) {
                    this.queryParams.ppa_code = this.postList.params.ppa_code;
                }

                if (this.postList.params.month) {
                    this.queryParams.month = this.postList.params.month;
                }

                this.getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        show_help() {
            this.is_show_help = this.is_show_help == false ? true : false;
        },
        in_array,
        //跳转详情
        toDetail(row, prop) {
            if (in_array(prop, ['rid']) && row.rid) {
                this.$router.push({
                    path: '/commodityFlowDetail',
                    query: {
                        id: row.rid
                    }
                });
            } else if (prop == 'ppa_code' && row.ppa_rid != '') {
                this.$router.push({
                    path: '/partnerProductAccountDetail',
                    query: {
                        id: row.ppa_rid
                    }
                });
            }
        },
        //刷新流向
        flushAcount() {
            var params = {};
            let messages = '此操作将刷新流向，是否继续?';
            this.$msgbox(messages, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api
                        .commodityFlowSourceFlush(params)
                        .then((res) => {
                            this.btnLoading = false;
                            if (res.code == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '刷新成功',
                                    type: 'success'
                                });
                                this.getList(0);
                            }
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消刷新'
                    });
                });
        },
        flushIsPpa() {
            var params = {};
            let messages = '此操作将刷新流向PPA标记，是否继续?';
            this.$msgbox(messages, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api
                        .commodityFlowSourceFlushIsPpa({})
                        .then((res) => {
                            this.btnLoading = false;
                            if (res.code == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '刷新成功',
                                    type: 'success'
                                });
                                this.getList(0);
                            }
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消刷新'
                    });
                });
        },
        flushPerformanceUnitCode() {
            this.$confirm('您确定要刷新吗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['flushFlowPerformanceUnitCode']({})
                        .then((res) => {
                            this.btnLoading = false;
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功！',
                                    type: 'success'
                                });
                            }
                            this.reload();
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        flushBusinessUnitCode() {
            this.$confirm('您确定要刷新吗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['flushFlowBusinessUnitCode']({})
                        .then((res) => {
                            this.btnLoading = false;
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功！',
                                    type: 'success'
                                });
                            }
                            this.reload();
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        relationProduct() {
            this.$router.push({
                path: 'flowProductList',
                query: {}
            });
        },
        relationSupplier() {
            this.$router.push({
                path: 'flowSupplierList',
                query: {}
            });
        },
        relationDemander() {
            this.$router.push({
                path: 'flowDemanderList',
                query: {}
            });
        },
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0,
                config01_rid: (this.postList.params && this.postList.params.config01_rid) || '',
                ppa_code: (this.postList.params && this.postList.params.ppa_code) || '',
                month: (this.postList.params && this.postList.params.month) || ''
            };

            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('commodity_flow_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('commodity_flow_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('commodity_flow', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).commodity_flow;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载 2
        getList(search_type = 0) {
            onSearch(search_type, this, 'commodityFlowSourceLists');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        reset() {
            this.initQueryParams();
            this.getList();
        },
        //删除
        del(row) {
            onDelete(row.id, this, 'commodityFlowDelete', row.rid);
        },
        //复制
        copy(rid) {
            this.$router.push({
                path: 'commodityFlowEdit',
                query: {
                    type: 'copy',
                    id: rid
                }
            });
        },
        //新增
        insert() {
            this.$router.push({
                path: 'commodityFlowEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //编辑
        update(rid) {
            this.$router.push({
                path: 'commodityFlowEdit',
                query: {
                    type: 'update',
                    id: rid
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>